module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_sentrert_logo_stor_pos.fe484eb0.pdf";